// extracted by mini-css-extract-plugin
module.exports = {"efmodal":"NoteModal_efmodal__4rRfd"};